import { CloseOutlined, HomeOutlined, MenuOutlined, ShoppingCartOutlined, UnorderedListOutlined, EuroCircleOutlined } from '@ant-design/icons';
import { message } from 'antd';
import { Auth } from 'aws-amplify';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router';
import { Button, Dropdown, Form, Icon, Modal } from 'semantic-ui-react';
import { LANDING_PAGE_URI } from '../../../constants';
import avatar from '../../../images/avatar.svg';
import logo from '../../../images/blueLogo.png';
import orders from '../../../images/orders.svg';
import persons from '../../../images/persons.svg';
import { isAdmin } from '../../../utils/AuthorizationValidation';
import { translations } from '../../../utils/LocalizedStrings';
import { getAllUrlParams } from '../../../utils/url';
import UserOrdersListPage from '../user/UserOrdersList.page';
import MyDocumentListPage from '../user/my-documents/MyDocumentList.page';
import LoginModal from './LoginModal';
import { GetUserdataAction, GetUserSignatureRequestsListAction, ProcessMyDocumentAction, SaveUserdataAction } from '../../../app/ActionsImpl';
import { PersonList } from './inputs/Person/PersonList';
import Subscription from '../user/Subscription';
import signed from '../../../images/signed.svg';
import UserSignatureRequestsListPage from '../user/UserSignatureRequestsList.page';

function UserProfile({ user, getUserdata, saveUserdata, processMyDocuments, ordersList }) {
    const [activeNav, setActiveNav] = useState('Moje objednávky');
    const [activeDrawer, setActiveDrawer] = useState(false);
    const [landingPage, setLandingPage] = useState(undefined);
    const [openUserStatusModal, setOpenUserStatusModal] = useState(false)
    const [actualOrdersList, setActualOrdersList] = useState()

    const history = useHistory();

    useEffect(() => {
        let search = window.location.search
        const urlParams = getAllUrlParams()
        if (urlParams.adm === undefined && isAdmin()) {
            if (search.indexOf("?") !== -1) {
                search += '&adm=01'
            } else {
                search += '?adm=01'
            }
            if (history) {
                history.push({
                    pathname: window.location.pathname,
                    search: search
                })
            }
        }
        if (urlParams.page !== undefined) {
            console.log(urlParams.page)
            toggleNav(urlParams.page)
        }
    }, [user])

    useEffect(() => {
        if (getAllUrlParams().signfilerequest !== undefined) {
            toggleNav('Žiadosti o podpis')
        }
    }, [])

    useEffect(() => {
        if (ordersList?.docs && ordersList.docs.length) {
            let tmpOrderList = JSON.parse(JSON.stringify(ordersList))
            let tmpDocsList = tmpOrderList.docs.filter((doc) => {
                let tmpDownloadList = doc.downloads.filter((download) => !alreadySigned(download))
                doc.downloads = tmpDownloadList
                return tmpDownloadList.length ? true : false
            })
            tmpOrderList.docs = tmpDocsList
            setActualOrdersList(tmpOrderList)
            console.log("here")
        }
    }, [ordersList])

    useEffect(() => {
        setLandingPage(LANDING_PAGE_URI)
    }, [])

    const toggleNav = (index) => {
        setActiveNav(index)
    };

    const toggleDrawer = () => {
        setActiveDrawer(!activeDrawer);
    };

    const signOut = async () => {
        try {
            window.location = landingPage
            await Auth.signOut();
        } catch (error) {
            console.log(error)
            message.error(error)
        }
    }

    const alreadySigned = (documentItem) => {
        let filtered = documentItem.imageSignatures?.filter((s) => s === documentItem.signature)
        if (filtered?.length) {
            return true
        } else {
            let requiredKep = documentItem.signedFile?.requiredSignatures?.filter((s) => s === documentItem.signature)
            if (requiredKep?.length) {
                return requiredKep?.length
            }
            return false
        }
    }

    const editBilling = async (e) => {
        e.preventDefault()
        window.location = window.location.pathname + "?page=predplatne&editbilling=true"
    }

    const handleNavClick = (navKey) => {
        toggleNav(navKey);
        setActiveDrawer(false);
    };

    return (
        user ? <>
            <div className="userProfileContainer">
                <Modal
                    onClose={() => setOpenUserStatusModal(false)}
                    onOpen={() => setOpenUserStatusModal(true)}
                    open={openUserStatusModal}
                    className="userStatusModal"
                    dimmer="blurring">
                    <Modal.Content>
                        <Modal.Description>
                            <Form onSubmit={signOut} className="orderUiForm userStatusModalWindow">
                                <div className='userStatusRow'>
                                    <div><img class="avatarLogo" src={avatar} alt="user avatar" width="100" /></div>
                                    <div>
                                        <div className='userName'>{user.attributes.given_name} {user.attributes.family_name}</div>
                                        <div className='userEmail'>{user.attributes.email}</div>
                                    </div>
                                </div>
                                <CloseOutlined className='userStatusModalCloseIcon' onClick={() => setOpenUserStatusModal(false)} />
                                <button
                                    className='edit-billing-button'
                                    onClick={editBilling}>
                                    <Icon name="euro sign" />
                                    {translations.artifacts.UserProfileBox.billingInfo}
                                </button>
                                <Button
                                    className="logoutButton"
                                    type="submit" onClick={signOut}>
                                    <Icon name="log out" />
                                    {translations.artifacts.UserProfileBox.logOut}
                                </Button>
                            </Form>
                        </Modal.Description>
                    </Modal.Content>
                </Modal>

                <div className='userContainer' onClick={() => setOpenUserStatusModal(true)}>
                    <span className='userName'>
                        {user && (
                            <>{user.attributes.given_name} {user.attributes.family_name}</>
                        )
                        }
                    </span>
                    <img
                        className="avatarLogo"
                        src={avatar}
                        alt="user avatar"
                        width={50}
                    />
                </div>
                <div className={activeDrawer ? 'menuIcon active' : 'menuIcon'}
                    onClick={toggleDrawer}>
                    <MenuOutlined />
                </div>
                <aside className={activeDrawer ? 'active' : ''}>
                    <div className="top">
                        <div className="logo">
                            <a onClick={() => { window.location = LANDING_PAGE_URI }}>
                                <img
                                    className="mainLogo"
                                    src={logo}
                                    alt="orsr logo"
                                />
                            </a>
                        </div>
                        <div className={activeDrawer ? 'close active' : 'close'} onClick={toggleDrawer}>
                            <CloseOutlined />
                        </div>
                    </div>
                    <div className="sidebar">
                        <a onClick={() => { window.location = LANDING_PAGE_URI }}>
                            <HomeOutlined />
                            <h3>{translations.artifacts.UserProfileBox.homePage}</h3>
                        </a>
                        {/* <a className={activeNav === 'Aktuálne akcie' ? 'active handshake' : 'handshake'} onClick={() => toogleNav('Aktuálne akcie')}>
                            <img
                                className="handshakeIcon"
                                src={handshake}
                                alt="handshake"
                                width={50}
                            />
                            <h3>{translations.artifacts.UserProfileBox.actions}</h3>
                        </a> */}
                        <a className={activeNav === 'Moje objednávky' ? 'active' : ''}
                            onClick={() => handleNavClick('Moje objednávky')}>
                            <img src={orders} className="signedDocumentIcon" alt='signedDocumentIcon' />
                            <h3>{translations.artifacts.UserProfileBox.myOrders}</h3>
                        </a>
                        {/* <a className={activeNav === 'Moje dokumenty' ? 'active' : ''} onClick={() => toggleNav('Moje dokumenty')}>
                            <UnorderedListOutlined />
                            <h3>{translations.artifacts.UserProfileBox.myDocuments}</h3>
                        </a> */}
                        <a className={activeNav === 'Žiadosti o podpis' ? 'active' : ''}
                            onClick={() => handleNavClick('Žiadosti o podpis')}>
                            <img src={signed} className="signedDocumentIcon" alt='signedDocumentIcon' />
                            <h3>{translations.artifacts.UserProfileBox.signatureRequests}</h3>
                            {actualOrdersList && actualOrdersList.docs.length > 0 && <span className='userProfileTemplateSignatureNotification'></span>}
                        </a>
                        <a className={activeNav === 'Moje osoby' ? 'active' : ''}
                            onClick={() => handleNavClick('Moje osoby')} >
                            <img
                                className="handshakeIcon"
                                src={persons}
                                alt="person"
                                width={50}
                            />
                            <h3>{translations.artifacts.UserPersonsBox.menuTitle}</h3>
                        </a>
                        <a className={activeNav === 'predplatne' ? 'active' : ''}
                            onClick={() => handleNavClick('predplatne')}>
                            <EuroCircleOutlined />
                            <h3>{translations.artifacts.UserPersonsBox.subscription}</h3>
                        </a>
                        <a>
                            <ShoppingCartOutlined />
                            <Dropdown item text='Nový dokument'>
                                <Dropdown.Menu>
                                    <Dropdown.Item><a href='https://www.mojezmluvy.sk/' target="_blank">MOJEZMLUVY.SK | Nová zmluva</a></Dropdown.Item>
                                    <Dropdown.Item><a href='https://orsr.help/?action=schvalenie-uctovnej-zavierky' target="_blank">ORSR.HELP | Účtovna závierka</a></Dropdown.Item>
                                    <Dropdown.Item><a href='https://orsr.help/?action=zmeny-v-sro' target="_blank">ORSR.HELP | Zmena v s.r.o.</a></Dropdown.Item>
                                    <Dropdown.Item><a href='https://orsr.help/?action=zalozit-sro' target="_blank">ORSR.HELP | Založenie s.r.o.</a></Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </a>
                    </div>
                </aside>
                {
                    activeNav === 'Moje objednávky' &&
                    <main>
                        <header>
                            <h2>{translations.artifacts.UserProfileBox.progress}</h2>
                        </header>
                        <div className='ordersTable'>
                            <UserOrdersListPage />
                        </div>
                    </main>
                }
                {
                    activeNav === 'Žiadosti o podpis' &&
                    <main>
                        <header>
                            <h2>{translations.artifacts.UserProfileBox.signatureRequests}</h2>
                        </header>
                        <div className='ordersTable'>
                            <UserSignatureRequestsListPage />
                        </div>
                    </main>
                }
                {
                    activeNav === 'Moje dokumenty' &&
                    <main>
                        <header>
                            <h2>{translations.artifacts.UserProfileBox.myDocuments}</h2>
                        </header>
                        <div className='ordersTable'>
                            <MyDocumentListPage />
                        </div>
                    </main>
                }
                {
                    activeNav === 'Moje osoby' &&
                    <main>
                        <header>
                            <h2>{translations.artifacts.UserPersonsBox.menuTitle}</h2>
                        </header>
                        <PersonList
                            getUserdata={getUserdata}
                            saveUserdata={saveUserdata}
                            processMyDocuments={processMyDocuments} />
                    </main>
                }
                {
                    activeNav === 'predplatne' &&
                    <main>
                        <header>
                            <h2>{translations.artifacts.UserPersonsBox.subscription}</h2>
                        </header>
                        <Subscription />
                    </main>
                }
                {
                    activeNav === 'Videonávody' && <main>
                        <header>
                            <h2>{translations.artifacts.UserProfileBox.videoBlog}</h2>
                        </header>
                        <div className='buttonsContainer'>
                            <h1>{translations.artifacts.UserProfileBox.preparing}</h1>
                        </div>
                    </main>
                }
            </div >
        </>
            :
            <LoginModal visible={true} handleClose={() => { }} />
    );
}

const mapStateToProps = ({ appState }) => ({
    user: appState.cognitoUser,
    ordersList: appState.signatureRequestsList,
});

const mapDispatchToProps = {
    getUserdata: GetUserdataAction,
    saveUserdata: SaveUserdataAction,
    processMyDocuments: ProcessMyDocumentAction,
    getOrderList: GetUserSignatureRequestsListAction
};

export default connect(mapStateToProps, mapDispatchToProps)(UserProfile);